/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useState } from "react";

interface Props {
  getPersistedForm<Form>(key: string): Form | undefined;

  persistForm<Form>(key: string, v: Form): void;
}

const context = React.createContext<Props>({
  getPersistedForm() {
    return undefined;
  },
  persistForm() {},
});

export const PersistedFormContext: React.FC = ({ children }) => {
  const [persistedForms, setPersistedForms] = useState<
    Record<string, any | undefined>
  >({});

  const value: Props = {
    getPersistedForm<Form>(key: string): Form | undefined {
      return persistedForms[key];
    },
    persistForm<Form>(key: string, v: Form) {
      setPersistedForms((persistedForms) => ({
        ...persistedForms,
        [key]: v,
      }));
    },
  };

  return <context.Provider value={value}>{children}</context.Provider>;
};

export const usePersistedForm = () => {
  return useContext(context);
};
